module.exports = __webpack_public_path__ + "static/img/anxun53.1606ad51.png";